import { ProductRangeCategoryInterface } from "../../../common/utils/productRange/mergeCategoriesWithProducts";
import { JSX, useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { ProductListHeader } from "@hatch-digital-nl/bravilor-storybook";
import { useNavigate } from "react-router-dom";
import { openCategory, selectProduct } from "../ProductRangeSlice";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { SimpleProduct } from "../../../common/utils/productConverters";
import { ProductIndexItemInterface } from "../../../common/interfaces/apiV2/shared/ProductIndexItemInterface";
import { isLeafCategory } from "../../../common/utils/productRange/isLeafCategory";
import { CategoryProductListContainer } from "./CategoryProductListContainer";

interface Props {
    child: ProductRangeCategoryInterface;
    disableCheckbox?: boolean;
}

export const CategorySubItem = (props: Props): JSX.Element => {
    const { child } = props;
    const { children, id } = child;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [active, setActive] = useState(false);
    const isLeaf = isLeafCategory(child);

    const handleToggle = (): void => {
        const nextActive = !active;
        setActive(nextActive);

        if (isLeaf && nextActive) {
            dispatch(openCategory(id));
        }
    };

    const handleProductSelect = (product: SimpleProduct): void => {
        dispatch(
            selectProduct(product.originalProduct as ProductIndexItemInterface),
        );
    };

    const handleProductClick = (product: SimpleProduct): void => {
        navigate(RouteEnum.PRODUCT_RANGE + `/${product.originalProduct.id}`);
    };

    return (
        <div
            className={
                "c-products-list__sub-item " +
                (active ? "is-active " : "in-active ") +
                (children.length > 0
                    ? "c-products-list__sub-item--active-white"
                    : "")
            }
        >
            <ProductListHeader
                isActive={active}
                onToggle={handleToggle}
                label={child.label}
                showIcon={true}
                variant={"sub"}
            />

            {children.length > 0 ? (
                <div className="c-products-list__sub-items">
                    {children.map((item) => (
                        <CategorySubItem
                            key={"category-" + item.id}
                            child={item}
                            disableCheckbox={props.disableCheckbox}
                        />
                    ))}
                </div>
            ) : (
                <div
                    className="c-products-list__sub-items"
                    style={{ padding: 0 }}
                >
                    <div
                        className={
                            "c-products-list__sub-item " +
                            (active ? "is-active" : "in-active")
                        }
                        style={{ margin: 0 }}
                    >
                        <CategoryProductListContainer
                            categoryId={id}
                            isExpanded={active}
                            onProductSelect={handleProductSelect}
                            onProductClick={handleProductClick}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
